import React, { useState } from "react";
import Calendar from "react-calendar";
import { Card, Box } from "@mui/material";
import "./CalendarStyles.css";

const MyCalendar = ({ onDateChange, blackoutDates = [] }) => {
  console.log(blackoutDates);
  const [value, setValue] = useState(new Date());

  const onChange = (nextValue) => {
    setValue(nextValue);
    const formattedDate = `${nextValue.getFullYear()}-${String(
      nextValue.getMonth() + 1
    ).padStart(2, "0")}-${String(nextValue.getDate()).padStart(2, "0")}`;
    onDateChange(formattedDate);
  };

  const getNextDayDate = () => {
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
  };

  const isBlackoutDate = ({ date }) => {
    console.log(`Incoming Date from Calendar: ${date}`);

    const formattedDateForIncoming = `${date.getFullYear()}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

    console.log("Checking:", formattedDateForIncoming);
    blackoutDates.forEach((bDate) => console.log("Against:", bDate.date));
    return blackoutDates.some(
      (blackoutDate) => blackoutDate.date === formattedDateForIncoming
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
      }}
    >
      <Card elevation={3}>
        <Box sx={{ p: 3 }}>
          <Calendar
            onChange={onChange}
            value={value}
            minDate={getNextDayDate()} // Disable past dates
            tileDisabled={isBlackoutDate} // Disable blackout dates
          />
        </Box>
      </Card>
    </Box>
  );
};

export default MyCalendar;
